import React from 'react';
import { Upload } from 'lucide-react';
import { FileUpload } from '../common/FileUpload';

interface ResumeUploadProps {
  userId: string;
  onUpload: (file: File) => void;
  isSubmitting?: boolean;
}

export function ResumeUpload({ userId, onUpload, isSubmitting }: ResumeUploadProps) {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('application/pdf')) {
      toast.error('Please upload a PDF file');
      return;
    }

    // Validate file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('File size must be less than 5MB');
      return;
    }

    onUpload(file);
  };

  return (
    <div className="p-6 bg-gray-50 rounded-xl">
      <div className="flex items-center space-x-2 mb-4">
        <Upload className="h-5 w-5 text-[#800020]" />
        <h3 className="text-sm font-medium text-black">Upload Resume</h3>
      </div>

      <div className={`relative ${isSubmitting ? 'opacity-50 pointer-events-none' : ''}`}>
        <input
          type="file"
          accept=".pdf"
          onChange={handleFileChange}
          className="hidden"
          id="resume-upload"
        />
        <label
          htmlFor="resume-upload"
          className="w-full h-32 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl hover:border-[#800020] transition-colors cursor-pointer"
        >
          <Upload className="h-8 w-8 text-gray-400 mb-2" />
          <span className="text-sm text-gray-500">Click to upload resume (PDF)</span>
        </label>
      </div>
      
      <p className="mt-2 text-xs text-gray-500">
        Maximum file size: 5MB. Accepted format: PDF
      </p>
    </div>
  );
}